import { DoctorGroup } from './groupCandidatesByDoctor';
import { ApsSource } from './types';

export type ApsListFilter = 'All' | ApsSource;

const groupMatchesSearch = (g: DoctorGroup, q: string): boolean =>
  g.name.toLowerCase().includes(q) ||
  g.npi.toLowerCase().includes(q) ||
  g.specialization.toLowerCase().includes(q) ||
  g.city.toLowerCase().includes(q) ||
  g.information.toLowerCase().includes(q) ||
  g.icds.some(
    icd =>
      icd.code.toLowerCase().includes(q) ||
      icd.description.toLowerCase().includes(q),
  );

const groupMatchesFilter = (g: DoctorGroup, filter: ApsListFilter): boolean =>
  filter === 'All' || g.source === filter;

export const filterDoctors = (
  groups: DoctorGroup[],
  filter: ApsListFilter,
  query: string,
): DoctorGroup[] => {
  const q = query.trim().toLowerCase();
  return groups.filter(
    g =>
      groupMatchesFilter(g, filter) && (q === '' || groupMatchesSearch(g, q)),
  );
};
